import React, {useState} from "react";
import { ListItem,  ListItemText, List, Dialog, IconButton } from '@mui/material';
import ComplaintsFull from "./complaints-full";
import SendIcon from '@mui/icons-material/Send';
import HideSourceIcon from '@mui/icons-material/HideSource';
import AddIcon from '@mui/icons-material/Add';


const ComplaintsCard = (props) => {
    
var {nhtsaIdNumber, description, vin, associatedProductsCount, associatedDocumentsCount} = props;

const [open, setOpen] = useState(false);

const handleClose = () =>{
    setOpen(false);
}

return (
    <List
        sx={{
            margin: 0,
            padding: 0,
            width: '100%',
            borderRadius: 0,
            borderColor: 'divider',
            //backgroundColor: '#ebe3e3',
            //p8Ozz44B5-MIXViQ3rOk
        }}
        
    >
        <ListItem>
            <ListItemText primary={`NHTSA ID: ${nhtsaIdNumber}`} secondary= {`${description?.substr(0, 150)}...`} />
        </ListItem>
        <ListItem>
            <ListItemText primary="VIN" secondary= {`${vin}`} />
            <ListItemText primary="Affected Products" secondary= {`${associatedProductsCount}`} />
            <ListItemText primary="Associated Documents" secondary= {`${associatedDocumentsCount}`} />
            {/* <IconButton variant="contained" color="primary"><AddIcon /></IconButton> */}
            <IconButton onClick={()=>setOpen(true)} variant="contained" color="primary"><SendIcon /></IconButton>
        </ListItem>
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
        >
            <ComplaintsFull {...{...props, setOpen: setOpen}}/>
        </Dialog>
    </List>
)}

export default ComplaintsCard;